"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _attach = _interopRequireDefault(require("./attach"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _icon = _interopRequireDefault(require("./icon"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Tabs = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs() {
    var _this;

    (0, _classCallCheck2.default)(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (event, value) {
      var _this$props = _this.props,
          component = _this$props.component,
          items = _this$props.items;
      component.set({
        value
      });
      var itemName = items[value].name;
      component.emitChange(itemName);
    });
    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          items = _this$props2.items,
          value = _this$props2.value; // FUTURE: option to make this fixed under the main app bar?

      return /*#__PURE__*/_react.default.createElement(_AppBar.default, {
        position: "static",
        color: "default",
        elevation: 1 // tone down the elevation>

      }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
        value: value,
        onChange: this.handleChange,
        indicatorColor: "primary",
        textColor: "primary",
        scrollButtons: "auto",
        variant: "fullWidth"
      }, items.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_Tab.default, {
          label: item.label,
          icon: /*#__PURE__*/_react.default.createElement(_icon.default, {
            icon: item.icon
          }),
          key: index
        });
      })));
    }
  }]);
  return Tabs;
}(_react.default.Component);

Tabs = (0, _attach.default)(['items', 'value'])(Tabs);
var _default = Tabs;
exports.default = _default;